import React, { Fragment } from 'react'
import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import Controls from './Controls';
import Indicator from './Indicator';
import SpeedyTag from '../SpeedyTag';

const Image = styled.img`
  /* margin-bottom: 60px; */
`;

const Tag = styled(SpeedyTag)`
margin-top: -30px;
`;

const Title = styled.h3`
  color: white;
  font-size: 1.875em;
  margin: 0;
`;

const Warning = styled.p`
  margin-top: 20px;
  font-size: 1.2em;
  font-weight: bold;
  color: #CF0207;
  text-transform: uppercase;

  &:before, &:after {
    content: '  !  ';
  }
`;

const Tip = styled.p`
  padding: 30px;
  padding-top: 0;
  font-size: 1.2em;
  color: white;
`;

const StyledCarousel = styled(Carousel)`
  .carousel-slider {
    padding-bottom: 40px;
    margin-bottom: 30px;
  }
`;

const Slide = styled.div`
  @media (min-width: 577px) {
    border: 2px solid #599BA4;
  }
`;

const turnIndex = (turnNumber, turns) => (
  turns.findIndex(turn => turn.number == turnNumber)
);

const nextTurn = (currentTurn, turns) => {
  const currentIndex = turnIndex(currentTurn, turns);
  if (currentIndex >= turns.length - 1) return currentTurn;

  return turns[currentIndex + 1].number;
};

const prevTurn = (currentTurn, turns) => {
  const currentIndex = turnIndex(currentTurn, turns);
  if (currentIndex == 0) return currentTurn;

  return turns[currentIndex - 1].number;
};

const renderIndicator = (turns, onTurnChange, isSelected, index) => {
  const onClick = () => onTurnChange(turns[index].number);
  return(<Indicator onClick={onClick} isSelected={isSelected} index={index} />);
}

const TurnCarousel = ({ turns, currentTurn, onTurnChange }) => (
  <Fragment>
    <StyledCarousel selectedItem={turnIndex(currentTurn, turns)}
                    showThumbs={false}
                    showArrows={false}
                    showStatus={false}
                    renderIndicator={(_handler, isSelected, index) => (
                      renderIndicator(turns, onTurnChange, isSelected, index)
                    )}>
      {turns.map(turn => (
        <Slide>
          <Image src={turn.image_url} />
          <Tag>
            <Title>Turn {turn.name || turn.number}</Title>
          </Tag>
          <Warning>Caution</Warning>
          <Tip>{turn.headline}</Tip>
        </Slide>
      ))}
    </StyledCarousel>
    <Controls
      nextHandler={() => onTurnChange(nextTurn(currentTurn, turns))}
      prevHandler={() => onTurnChange(prevTurn(currentTurn, turns))}
    />
  </Fragment>
);

export default TurnCarousel;
